<template>
  <div class="materialManage">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="物料管理" name="first">
          <span
            class="childTabs"
            :class="{activeLink: twoTabPaneValue=='first'}"
            @click="twoTabPaneClick('first')"
          >物料编码</span>
          <span class="childTabs"
             v-for="(item, index) in tabPaneList"
            :key="item.id"
            :label="item.itemCode"
            :name="item.itemCode"
            @click="twoTabPaneClick(item.itemCode)"
            :class="{activeLink: twoTabPaneValue==item.itemCode}"
          >{{item.itemCode}}<i
              class="el-icon-circle-close"
              @click.stop="twoCloseTabPane(index)"
            ></i></span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="left"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button v-if="tabPaneValue == 'first' && twoTabPaneValue == 'first'"
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
            <el-button v-if="tabPaneValue == 'first' && twoTabPaneValue != 'first'"
              type="primary"
              icon="el-icon-download"
              size="small"
              @click="exportExcelBtn"
              >导出</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button v-if="tabPaneValue == 'first'"
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="虚拟物料" name="virtual">
          <span
            class="childTabs"
            :class="{ activeLink: virtualType == 'table' }"
            @click="virtualChange('table')"
            >虚拟物料</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: virtualType == 'charts' }"
            @click="virtualChange('charts')"
            >图表视图</span
          >
          <div class="btnBox">
            <div class="searchBtnBox">
              <el-dropdown trigger="click" @command="uploadFileBtn">
                <el-button class="uploadDownBtn" type="primary" icon="el-icon-d-arrow-right" size="small">导入</el-button>
                <el-dropdown-menu slot="dropdown" class="uploadDropdown">
                  <el-dropdown-item command="KeyId">KeyId</el-dropdown-item>
                  <el-dropdown-item command="DLinkNum">DLinkNum</el-dropdown-item>
                  <el-dropdown-item command="IMEI">IMEI</el-dropdown-item>
                  <el-dropdown-item command="MAC">MAC</el-dropdown-item>
                  <el-dropdown-item command="TUTK">TUTK</el-dropdown-item>
                  <el-dropdown-item command="涂鸦">涂鸦</el-dropdown-item>
                  <el-dropdown-item command="NetId">NetId</el-dropdown-item>
                  <!-- <el-dropdown-item command="H3C">新华三备品</el-dropdown-item>
                  <el-dropdown-item command="iflyTek">科大讯飞备品</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
              <el-tooltip v-if="isMoreSearch" class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small"
                  class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-dropdown v-if="isMoreSearch" trigger="click" @command="downloadFileBtn">
                <el-button class="uploadDownBtn" type="primary" icon="el-icon-d-arrow-right" size="small">导出</el-button>
                <el-dropdown-menu slot="dropdown" class="downloadDropdown">
                  <el-dropdown-item command="图片" v-if="virtualType == 'charts'">导出图片</el-dropdown-item>
                  <el-dropdown-item command="Excel">导出Excel</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown v-if="isMoreSearch"
                split-button
                type="primary"
                size="small"
                class="searchBox"  @click="onSearch(false)"
                trigger="click"
              >
                查询
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onSearch(true)">模糊查询</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                class="btn_more"
                :class="{activeUserMore:isMoreSearch}"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="ADAS" name="adas">
          <span>ADAS清单</span>
          <div class="btnBox">
            <div class="searchBtnBox">
              <el-tooltip class="item" content="只看我的工单" placement="bottom" :open-delay="300">
                <el-checkbox v-model="adasRecordSearchForm.onlyMy" @change="onlyMySearch">我的工单</el-checkbox>
              </el-tooltip>
              <el-tooltip v-if="isMoreSearch" class="item" content="清除查询条件" placement="left" :open-delay="300"
              >
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button v-if="isMoreSearch"
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button v-if="tabPaneValue == 'adas'" type="primary" icon="el-icon-download" size="small"
              @click="exportExcelBtn" >导出</el-button>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button v-if="tabPaneValue == 'adas'"
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="外协标签" name="blueWay">
          <span
            @click="twoTabPaneClick('blueWayItemCode')"
            class="childTabs"
            :class="{activeLink: twoTabPaneValue=='blueWayItemCode'}">物料编码</span>
          <span
            @click="twoTabPaneClick('blueWayOrder')"
            class="childTabs"
            :class="{activeLink: twoTabPaneValue=='blueWayOrder'}">生产工单</span>
          <span v-if="blueWaySearchForm.sapOrderId"
            @click="twoTabPaneClick('blueWayStockRecord')"
            class="childTabs"
            :class="{activeLink: twoTabPaneValue=='blueWayStockRecord'}">检料记录</span>
          <div class="btnBox">
            <div class="searchBtnBox">
              <el-tooltip v-if="isMoreSearch" class="item" content="清除查询条件" placement="left" :open-delay="300"
              >
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button v-if="isMoreSearch"
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button v-if="twoTabPaneValue=='blueWayItemCode'" type="primary" icon="el-icon-upload2" size="small"
              @click="importBlueWayExcelBtn">导入</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button v-if="tabPaneValue == 'blueWay'"
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="客户料号" name="lenovo">
          <span
            @click="twoTabPaneClick('lenovoMaterial')"
            class="childTabs"
            :class="{activeLink: twoTabPaneValue=='lenovoMaterial'}">联想物料编码</span>
          <span
            @click="twoTabPaneClick('lenovoPartCode')"
            class="childTabs"
            :class="{activeLink: twoTabPaneValue=='lenovoPartCode'}">联想配件编码</span>
          <div class="btnBox">
            <el-button v-if="isMoreSearch && tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoMaterial'" type="primary" icon="el-icon-document-copy" size="small"
              @click="copyLenovoMaterial">复制</el-button>
            <el-button v-if="isMoreSearch && tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoMaterial'" type="primary" icon="el-icon-upload2" size="small"
              @click="lenovoMaterialUpload">导入</el-button>
            <el-button v-if="isMoreSearch && tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoMaterial'" type="primary" icon="el-icon-download" size="small"
              @click="lenovoMaterialExport">导出</el-button>
            <el-button v-if="isMoreSearch && tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoPartCode'" type="primary" icon="el-icon-upload2" size="small"
              @click="lenovoPartCodeUpload">导入</el-button>
            <el-button v-if="isMoreSearch && tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoPartCode'" type="primary" icon="el-icon-download" size="small"
              @click="lenovoPartCodeExport">导出</el-button>
            <div class="searchBtnBox">
              <el-tooltip v-if="isMoreSearch" class="item" content="清除查询条件" placement="left" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button v-if="isMoreSearch"
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button v-if="tabPaneValue == 'lenovo'"
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
            <el-button v-if="tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoMaterial'" type="primary" icon="el-icon-plus" size="small"
              @click="addLenovoMaterial">新建</el-button>
            <el-button v-if="tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoPartCode'" type="primary" icon="el-icon-plus" size="small"
              @click="addLenovoPartCode">新建</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="isMoreSearch && tabPaneValue == 'first' && twoTabPaneValue == 'first'"
      >
        <div class="searchConditionBox">
          <el-form-item label="物料编码" size="small">
            <el-input
              v-model="searchConditionForm.itemCode"
              placeholder="输入物料编码"
              clearable
              @keyup.enter.native="getItemCodeSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="编码类型" size="small">
            <el-select
              v-model="searchConditionForm.type"
              placeholder="选择编码类型"
              filterable
              clearable
              @change="itemTypeChange('searchConditionForm')"
            >
              <el-option
                v-for="(item, index) in pullDownData.typeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchConditionForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange($event, 'searchConditionForm', 'productList')"
              :disabled="searchConditionForm.type != 'PRODUCT' && searchConditionForm.type != 'UUID'"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="searchConditionForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
              :disabled="searchConditionForm.type != 'PRODUCT'"
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品规格" size="small">
            <el-input
              v-model="searchConditionForm.specification"
              placeholder="输入产品规格"
              clearable
              @keyup.enter.native="getItemCodeSearch()"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="virtualSearchForm"
        class="demo-form-inline"
        v-else-if="tabPaneValue == 'virtual' && isMoreSearch"
      >
        <div class="searchConditionBox" v-if="virtualType == 'table'" key="table">
          <el-form-item label="UUID" size="small">
            <el-input v-model="virtualSearchForm.uuid" placeholder="UUID" clearable></el-input>
          </el-form-item>
          <el-form-item label="物料编码" size="small">
            <el-input v-model="virtualSearchForm.itemCode" placeholder="物料编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="UUID类别" size="small">
            <el-select v-model="virtualSearchForm.type" placeholder="UUID类别" filterable clearable @change="uuidTypeChange">
              <el-option v-for="(item, index) in pullDownData.uuidTypeList" :key="index" :label="item.title" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Key类型" size="small">
            <el-select  v-model="virtualSearchForm.p2pType" placeholder="UUID类别为P2P_UID有效" filterable clearable
             :disabled="virtualSearchForm.type != 'P2P_UID'">
              <el-option
                v-for="(item, index) in pullDownData.P2PTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="virtualSearchForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用情况" size="small">
            <el-select
              v-model="virtualSearchForm.used"
              placeholder="选择是否已使用"
              filterable
              clearable
              @change="usedChange"
            >
              <el-option label="已使用" :value="true"></el-option>
              <el-option label="未使用" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="virtualSearchForm.startDateTime"
              type="datetime"
              placeholder="使用时有效"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="startDateChange"
              :picker-options="$store.state.pickerOptions"
              :disabled="virtualSearchForm.used != true"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="virtualSearchForm.endDateTime"
              type="datetime"
              placeholder="使用时有效"
              @change="endDateChange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
              :disabled="virtualSearchForm.used != true"
            ></el-date-picker>
          </el-form-item>
        </div>
        <div class="searchConditionBox" v-else key="charts">
          <el-form-item label="物料编码" size="small">
            <el-input v-model="virtualSearchForm.itemCode" placeholder="物料编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="UUID类别" size="small">
            <el-select
              v-model="virtualSearchForm.type"
              placeholder="UUID类别"
              filterable
              clearable
              @change="uuidTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.uuidTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Key类型" size="small">
            <el-select
              v-model="virtualSearchForm.p2pType"
              placeholder="UUID类别为P2P_UID有效"
              filterable
              clearable
              :disabled="virtualSearchForm.type != 'P2P_UID'"
            >
              <el-option
                v-for="(item, index) in pullDownData.P2PTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="virtualSearchForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option label="通用库存" :value="0"></el-option>
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="uuidRecordSearchForm"
        class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue == 'first' && twoTabPaneValue != 'first'"
      >
        <div class="searchConditionBox" key="table">
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="uuidRecordSearchForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="startDateChange"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="uuidRecordSearchForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              @change="endDateChange"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>        
      </el-form>
      <el-form
        :inline="true"
        :model="adasRecordSearchForm"
        class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue == 'adas'"
      >
        <div class="searchConditionBox" key="table">
          <el-form-item label="工单号" size="small">
            <el-input v-model="adasRecordSearchForm.orderNumber" placeholder="组装工单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="SAP单号" size="small">
            <el-input v-model="adasRecordSearchForm.sapOrderNumber" placeholder="SAP单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-input v-model="adasRecordSearchForm.product" placeholder="产品型号" clearable></el-input>
          </el-form-item>
        </div>        
      </el-form>
      <el-form
        :inline="true"
        :model="adasRecordSearchForm"
        class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue == 'blueWay'"
      >
        <div v-if="twoTabPaneValue=='blueWayItemCode'" class="searchConditionBox" key="table">
          <el-form-item label="外协工厂编码" size="small">
            <el-input v-model="blueWaySearchForm.blueWay" placeholder="外协工厂物料编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="奥尼编码" size="small">
            <el-input v-model="blueWaySearchForm.aoni" placeholder="奥尼物料编码" clearable></el-input>
          </el-form-item>
        </div>
        <div v-if="twoTabPaneValue=='blueWayOrder'" class="searchConditionBox" key="table">
          <el-form-item label="工单号" size="small">
            <el-input v-model="blueWaySearchForm.aufnr" placeholder="SAP生产工单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="物料编码" size="small">
            <el-input v-model="blueWaySearchForm.matnr" placeholder="产品物料编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-input v-model="blueWaySearchForm.model" placeholder="产品型号" clearable></el-input>
          </el-form-item>
          <el-form-item label="销售订单" size="small">
            <el-input v-model="blueWaySearchForm.kdauf" placeholder="销售订单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="业务员" size="small">
            <el-input v-model="blueWaySearchForm.ktonr" placeholder="业务员" clearable></el-input>
          </el-form-item>
        </div>
        <div v-if="twoTabPaneValue=='blueWayStockRecord'" class="searchConditionBox" key="table">
          <el-form-item label="出库单号" size="small">
            <el-input v-model="blueWaySearchForm.stockNum" placeholder="SAP出库单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="物料编码" size="small">
            <el-input v-model="blueWaySearchForm.itemCode" placeholder="产品物料编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="LPN" size="small">
            <el-input v-model="blueWaySearchForm.grn" placeholder="包装条码" clearable></el-input>
          </el-form-item>
          <el-form-item label="检料单号" size="small">
            <el-input v-model="blueWaySearchForm.lotNum" placeholder="检料单号" clearable></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="lenovoSearchForm"
        class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoMaterial'"
      >
        <div class="searchConditionBox">
          <el-form-item label="MTM" size="small">
            <el-input v-model="lenovoSearchForm.mtm" placeholder="MTM" clearable
              @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="SN前缀" size="small">
            <el-input v-model="lenovoSearchForm.partSnPrefix" placeholder="配件SN前缀" clearable
              @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="联想料号" size="small">
            <el-input v-model="lenovoSearchForm.lenovoPartNumber" placeholder="联想料号" clearable
              @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="10位长码" size="small">
            <el-select v-model="lenovoSearchForm.customerSupplied" placeholder="选择是否" clearable>
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="lenovoPartCodeSearchForm"
        class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoPartCode'"
      >
        <div class="searchConditionBox">
          <el-form-item label="配件类型" size="small">
            <el-input v-model="lenovoPartCodeSearchForm.partType" placeholder="配件类型" clearable
              @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="配件名称" size="small">
            <el-input v-model="lenovoPartCodeSearchForm.partName" placeholder="配件名称" clearable
              @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
          <el-form-item label="配件编码" size="small">
            <el-input v-model="lenovoPartCodeSearchForm.partCode" placeholder="配件编码" clearable
              @keyup.enter.native="onSearch"></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="contentBox">
      <div class="rightContent" v-if="tabPaneValue == 'first' && twoTabPaneValue == 'first'">
        <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini" @sort-change="sortChange">
          <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column prop="itemCode" align="center" sortable="custom"
            label="物料编码" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.itemCode" class="allowSkip" @click="clickAllowSkip(scope.row)">
                {{scope.row.itemCode}}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" align="center" sortable="custom" show-overflow-tooltip
            label="编码类型">
            <template slot-scope="scope">
              <span v-if="scope.row.type">{{ scope.row.type.title }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="productId" align="center" show-overflow-tooltip
            label="绑定产品">
            <template slot-scope="scope">
              <span v-if="scope.row.product">{{ scope.row.product.code }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="specification" align="center" show-overflow-tooltip
            label="产品规格">
            <template slot-scope="scope">
              <span v-if="scope.row.specification">
                {{scope.row.specification}}
              </span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="minStock" align="center" show-overflow-tooltip
            label="最低库存">
            <template slot-scope="scope">
              <span v-if="scope.row.minStock">{{ scope.row.minStock }}</span>
              <span v-else>-</span>
              <el-tooltip class="item" effect="dark" v-if="scope.row.minStock" :content="scope.row.mailTo ? (scope.row.mailCc ? scope.row.mailTo+','+scope.row.mailCc : scope.row.mailTo) :'未设置邮件接收人'" placement="top" :open-delay="300">
                <i style="margin-left:10px; cursor:pointer;" @click="handleMail(scope.row)" class="el-icon-message allowSkip"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="stock" align="center" show-overflow-tooltip
            label="当前库存">
            <template slot-scope="scope">
              <span v-if="scope.row.stock">{{ scope.row.stock }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column  class-name="operation" align="center" width="95px"
            label="操作">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
                <i @click="handleEdit(scope.row)" class="el-icon-edit"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getItemCodeSearch"
        ></pagination>
      </div>
      <virtualMaterial ref="virtualMaterial" v-if="tabPaneValue == 'virtual'" :virtualSearchForm="virtualSearchForm"></virtualMaterial>
      <div class="rightContent" v-else-if="tabPaneValue == 'first' && twoTabPaneValue != 'first'">
        <uuidRecord ref="uuidRecord" :twoTabPaneValue="twoTabPaneValue" :uuidRecordSearchForm="uuidRecordSearchForm"></uuidRecord>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'adas'">
        <adasRecord ref="adasRecord" :adasRecordSearchForm="adasRecordSearchForm"></adasRecord>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'blueWay'">
        <blueWay ref="blueWay" :blueWaySearchForm="blueWaySearchForm"></blueWay>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoMaterial'">
        <lenovoMaterial ref="lenovoMaterial" :lenovoSearchForm="lenovoSearchForm"></lenovoMaterial>
        <input ref="uploadLenovoMaterialInput" type="file" @change="lenovoFileChange()" style="display: none"/>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'lenovo' && twoTabPaneValue == 'lenovoPartCode'">
        <lenovoPartCode ref="lenovoPartCode" :lenovoPartCodeSearchForm="lenovoPartCodeSearchForm"></lenovoPartCode>
        <input ref="uploadLenovoPartCodeInput" type="file" @change="lenovoPartCodeFileChange()" style="display: none"/>
      </div>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form v-if="dialogTitle == '修改物料编码' || dialogTitle == '新建物料编码'" 
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="物料编码：" size="small" prop="itemCode">
            <el-input
              v-model="dialogForm.itemCode"
              placeholder="输入物料编码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="编码类型：" size="small" prop="type">
            <el-select
              v-model="dialogForm.type"
              placeholder="选择编码类型"
              filterable
              clearable
              @change="itemTypeChange('dialogForm')"
            >
              <el-option
                v-for="(item, index) in pullDownData.typeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格参数：" size="small" prop="specification">
            <el-input
              v-model="dialogForm.specification"
              placeholder="输入物料的规格参数信息"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="最低库存：" size="small" prop="minStock">
            <el-input-number
              v-model="dialogForm.minStock"
              :min="0"
              :precision="0"
              placeholder="最低库存数量"
              :controls="false"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="产品类别：" size="small">
            <el-select
              v-model="dialogForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="
                productTypeChange($event, 'dialogForm', 'addProductList')
              "
              :disabled="dialogForm.type != 'PRODUCT' && dialogForm.type != 'UUID'"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号：" size="small">
            <el-select
              v-model="dialogForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
              :disabled="dialogForm.type != 'PRODUCT' && dialogForm.type != 'UUID'"
            >
              <el-option
                v-for="(item, index) in pullDownData.addProductList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>


        <el-form v-if="dialogTitle == '邮件通知'" 
          ref="dialogMail"
          :model="dialogMail"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
        <!-- <el-form-item label="收件人：" size="small" prop="mailTo">
            <el-input
              v-model="dialogMail.mailTo"
              placeholder="输入收件人多个用英文逗号,隔开"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="抄送人：" size="small" prop="mailCc">
            <el-input
              v-model="dialogMail.mailCc"
              placeholder="输入抄送人多个用英文逗号,隔开"
              clearable
            ></el-input>
          </el-form-item> -->
         <el-form-item label="收件人" size="small">
            <el-select
              v-model="dialogMail.mailTo"
              placeholder="选择收件人"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'mailTo','邮箱选择', 'dialogMail')"
            >''
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="抄送人" size="small">
            <el-select
              v-model="dialogMail.mailCc"
              placeholder="选择抄送人"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event,'mailCc', '邮箱选择', 'dialogMail')"
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <orderTableSelect ref="orderTableSelect" @orderTableSubmit="orderTableSubmit"></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import virtualMaterial from "./components/virtualMaterial.vue";
import adasRecord from "./components/adasRecord.vue";
import uuidRecord from "./components/uuidRecord.vue";
import blueWay from "./components/blueWay"
import lenovoMaterial from "./components/lenovoMaterial.vue"
import lenovoPartCode from "./components/lenovoPartCode.vue"
import orderTableSelect from "@/components/orderTableSelect.vue";
import { apiUploadFile } from "@/api/filesUpload.js";
import {
  apiItemCodeSearch,
  apiItemCodeAdd,
  apiItemCodeUpdate,
  apiItemCodeType,
  apiProductTypeList,
  apiProductList,
  apiItemCodeUpdateEmailNotice,
  apiLenovoMaterialImport,
  apiLenovoPartCodeImport,
} from "@/api/itemCodeManage.js";
import {
  apiUuidType,
  apiP2PType,
  apiCustomerList,
} from "@/api/virtualMaterial.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/itemCodeManage", topTabVar: "tabPaneValue", topTabs: ["first", "virtual", "adas", "blueWay", "lenovo"], subTabs: { virtualType: ["table", "charts"], lenovoMaterial: ["lenovoMaterial", "lenovoPartCode"] } },
  components: {
    pagination,
    myDialog,
    virtualMaterial,
    uuidRecord,
    adasRecord,
    blueWay,
    lenovoMaterial,
    lenovoPartCode,
    orderTableSelect
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        if (this.twoTabPaneValue == "first") {
          this.getItemCodeSearch();
        } else {
          this.$nextTick(() => {
            this.$refs.uuidRecord.getUuidRecords();
          });
        }
      } else if (newVal=='virtual') {
        this.$nextTick(() => {
          this.$refs.virtualMaterial.virtualChange(this.virtualType);
          this.$refs.virtualMaterial.getProductItemCodeList();
        });
      } else if (newVal == 'adas') {
        this.$nextTick(() => {
            this.$refs.adasRecord.onSearch();
        });
      } else if (newVal == 'blueWay') {
        this.$nextTick(()=>{
          if(this.twoTabPaneValue=="first") {
            this.twoTabPaneValue = "blueWayItemCode";
          }
          this.$refs.blueWay.changeTab(this.twoTabPaneValue);
        });
      } else if (newVal == 'lenovo') {
        this.$nextTick(()=>{
          if(this.twoTabPaneValue!="lenovoMaterial" && this.twoTabPaneValue!="lenovoPartCode") {
            this.twoTabPaneValue = "lenovoMaterial";
          }
          if(this.twoTabPaneValue=="lenovoMaterial") {
            this.$refs.lenovoMaterial.onSearch();
          } else if(this.twoTabPaneValue=="lenovoPartCode") {
            this.$refs.lenovoPartCode.onSearch();
          }
        });
      }
    },

    twoTabPaneValue: function(newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        this.getItemCodeSearch();
      } else if (newVal=="blueWayItemCode" || newVal=="blueWayOrder" || newVal == "blueWayStockRecord") {
        this.$refs.blueWay.changeTab(this.twoTabPaneValue);
      } else if (newVal == "lenovoMaterial") {
        this.$nextTick(() => {
          this.$refs.lenovoMaterial.onSearch();
        });
      } else if (newVal == "lenovoPartCode") {
        this.$nextTick(() => {
          this.$refs.lenovoPartCode.onSearch();
        });
      } else {
        this.$nextTick(() => {
          this.$refs.uuidRecord.getUuidRecords();
        });
      }
    }
    
  },
  data() {
    let validateEmail = (rule, value, callback) => {
      let reg =  /^((([a-z0-9_.-]+)@([\da-z.-]+).([a-z.]{2,6},))*(([a-z0-9_.-]+)@([\da-z.-]+).([a-z.]{2,6})))$/;
      if (!value || reg.test(value)) {
        callback();
      } else {
        callback(new Error("邮箱格式错误"));
      }
    };
    return {
      tabPaneValue: "first",
      twoTabPaneValue: "first",
      virtualType: "table",
      tabPaneList: [],
      tabPaneData: {},
      nowRowData: {},
      isMoreSearch: false,
      searchConditionForm: {},
      virtualSearchForm: {
        like: false
      },
      uuidRecordSearchForm:{},
      adasRecordSearchForm:{},
      blueWaySearchForm:{},
      lenovoSearchForm:{},
      lenovoPartCodeSearchForm:{},
      pullDownData: {
        userList: [],
        typeList: [],
        productTypeList: [],
        productList: [],
        addProductList: [],
        uuidTypeList: [],
        P2PTypeList: [],
        customerList: []
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {
        minStock:0
      },
      dialogMail:{},
      dialogRules: {
        itemCode: [
          { required: true, message: "物料编码不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change",
          },
        ],
        type: [
          { required: true, message: "物料类型不能为空！", trigger: "blur" },
        ],
        minStock: [
          { required: true, message: "最低库存不能为空！", trigger: "blur" },
        ],
        specification: [
          { required: true, message: "物料规格参数不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 256,
            message: "长度在 2 到 256 个字符",
            trigger: "change",
          },
        ],
        mailTo:[
          { required: true, message: "发件人不能为空！", trigger: "blur" },
          {
            validator: validateEmail,
            trigger: "change",
          },
        ],
        mailCc:[
          {
            validator: validateEmail,
            trigger: "change",
          },
        ],
      },
      labelWidth: this.$store.state.labelWidth,
    };
  },
  methods: {
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    //切换二级面包
    twoTabPaneClick(value){
      this.twoTabPaneValue = value;
  },
    // 关闭二级面板
    twoCloseTabPane(index) {
      if (this.tabPaneList[index].itemCode == this.twoTabPaneValue) {
        if (index > 0) {
          this.twoTabPaneValue = this.tabPaneList[index - 1].itemCode;
        } else {
          this.twoTabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 切换虚拟--视图
    virtualChange(value) {
      this.virtualType = value;
      // this.virtualSearchForm.customerId =
      //   this.virtualSearchForm.customerId || "";
      this.$set(this.virtualSearchForm, "customerId", this.virtualSearchForm.customerId || "")
      this.$refs.virtualMaterial.virtualChange(value);
      this.$refs.virtualMaterial.getProductItemCodeList(value);
      this.$moreSearchStyle();
    },
    // 点击表格 物料编码
    clickAllowSkip(row) {
      this.nowRowData = row;
      this.twoTabPaneValue = row.itemCode;
      let tabPaneIds = this.tabPaneList.map((item) => item.itemCode);
      if (tabPaneIds.includes(row.itemCode)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.itemCode), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
    },
    // 表格数据
    async getItemCodeSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiItemCodeSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 新建物料编码
    addNewBtn() {
      this.dialogTitle = "新建物料编码";
      this.$refs.myDialog.dialogVisible = true;
    },
    exportExcelBtn() {
      if (this.tabPaneValue=='adas') {
        this.$refs.adasRecord.tableExport();
      } else if (this.tabPaneValue=='first') {
        this.$refs.uuidRecord.tableExport();
      } else {
        alert("错误的：【"+this.tabPaneValue+"】");
      }
    },
    importBlueWayExcelBtn() {
      this.$refs.blueWay.uploadFileBtn();
    },
    // 新建联想物料编码
    addLenovoMaterial() {
      this.$refs.lenovoMaterial.addNew();
    },
    // 复制联想物料编码
    copyLenovoMaterial() {
      this.$refs.lenovoMaterial.copyNew();
    },
    // 导入联想物料编码
    lenovoMaterialUpload() {
      this.$nextTick(() => {
        this.$refs.uploadLenovoMaterialInput.click();
      });
    },
    // 文件上传
    async lenovoFileChange() {
      let files = this.$refs.uploadLenovoMaterialInput.files;
      if (files.length) {
        let fd = new FormData();
        fd.append("file", files[0]);
        let res = await apiUploadFile(fd);
        if (res.code == 0) {
          this.$refs.uploadLenovoMaterialInput.value = "";
          const resImport = await apiLenovoMaterialImport({
            fid: res.fid,
          });
          if (resImport.code == 0) {
            this.$message({
              type: "success",
              message: resImport.msg,
            });
            this.$refs.lenovoMaterial.onSearch();
          }
        }
      }
    },
    // 导出联想物料编码
    lenovoMaterialExport() {
      this.$refs.lenovoMaterial.tableExport();
    },
    // 新建联想配件编码
    addLenovoPartCode() {
      this.$refs.lenovoPartCode.addNew();
    },
    // 导出联想配件编码
    lenovoPartCodeExport() {
      this.$refs.lenovoPartCode.tableExport();
    },
    // 导入联想配件编码
    lenovoPartCodeUpload() {
      this.$nextTick(() => {
        this.$refs.uploadLenovoPartCodeInput.click();
      });
    },
    // 联想配件编码文件上传
    async lenovoPartCodeFileChange() {
      let files = this.$refs.uploadLenovoPartCodeInput.files;
      if (files.length) {
        let fd = new FormData();
        fd.append("file", files[0]);
        let res = await apiUploadFile(fd);
        if (res.code == 0) {
          this.$refs.uploadLenovoPartCodeInput.value = "";
          const resImport = await apiLenovoPartCodeImport({
            fid: res.fid,
          });
          if (resImport.code == 0) {
            this.$message({
              type: "success",
              message: resImport.msg,
            });
            this.$refs.lenovoPartCode.onSearch();
          }
        }
      }
    },
    // 修改物料编码
    handleEdit(row) {
      this.dialogTitle = "修改物料编码";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id,
        itemCode: row.itemCode,
        type: row.type.code,
        specification: row.specification,
        minStock: row.minStock,
        productType: row.productType ? row.productType.code : "",
        productId: row.product ? row.product.id : "",
      };
      if (row.productType) {
        this.getProductList(row.productType.code, "addProductList");
      }
    },
    //邮件通知
    handleMail(row) {
      this.dialogTitle = "邮件通知";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogMail={
        id: row.id,
        mailTo:row.mailTo,
        mailCc:row.mailCc
      };
    },
    // 确认新建/修改
    submitData(title) {
      if(title == "新建物料编码" || title == "修改物料编码"){
         this.$refs.dialogForm.validate(async (valid) => {
          if (valid) {
            if (title == "新建物料编码") {
              const res = await apiItemCodeAdd({
                ...this.dialogForm,
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getItemCodeSearch("noRemove");
                this.$message({
                  message: "新建成功",
                  type: "success",
                });
              }
            } else if (title == "修改物料编码") {
              const res = await apiItemCodeUpdate({
                ...this.dialogForm,
              });
              if (res.code == 0) {
                this.$refs.myDialog.dialogVisible = false;
                this.getItemCodeSearch("noRemove");
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              }
            }
          } else {
            return false;
          }
      });
      }
       if(title == "邮件通知"){
         this.$refs.dialogMail.validate(async (valid) => {
          if (valid) {
          const res = await apiItemCodeUpdateEmailNotice({
            ...this.dialogMail,
          });
          if (res.code == 0) {
            this.$refs.myDialog.dialogVisible = false;
            this.getItemCodeSearch("noRemove");
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
          }
        });
       }
     
    },
    // 关闭对话框
    dialogClose(title) {
      if(title == "修改物料编码" || title=="新增物料编码"){
        this.$refs.dialogForm.resetFields();
        this.dialogForm = {
          minStock:0
        };
        this.pullDownData.addProductList = [];
      }
      if(title=="邮件通知"){
        this.$refs.dialogMail.resetFields();
      }
    },
    downloadFileBtn(type) {
      this.$refs.virtualMaterial.downloadFileBtn(type)
    },
    // 导入按钮
    uploadFileBtn(type) {
      this.$refs.virtualMaterial.uploadFileBtn(type)
    },
    // 清除查询
    onClear() {
      if(this.tabPaneValue == "first") {
        this.searchConditionForm = {};
        this.pagination.currentPage = 1;
        this.getItemCodeSearch();
      } else if(this.tabPaneValue == "first" && this.twoTabPaneValue != "first"){        
        this.$refs.uuidRecord.pagination.currentPage = 1;
        this.uuidRecordSearchForm = {};
      } else if (this.tabPaneValue=='adas') {
        this.$refs.adasRecord.pagination.currentPage = 1;
        this.adasRecordSearchForm = {};
      } else if (this.tabPaneValue=='blueWay') {
        this.$refs.blueWay.pagination.currentPage = 1;
        let sapOrderId = this.blueWaySearchForm.sapOrderId;
        this.blueWaySearchForm = {sapOrderId};
      } else if (this.tabPaneValue=='lenovo') {
        if(this.twoTabPaneValue=="lenovoPartCode") {
          this.$refs.lenovoPartCode.pagination.currentPage = 1;
          this.lenovoPartCodeSearchForm = {};
        } else {
          this.$refs.lenovoMaterial.pagination.currentPage = 1;
          this.lenovoSearchForm = {};
        }
      } else {
        this.virtualSearchForm = {
          like: false
        };
        this.$nextTick(() => {
          this.$refs.virtualMaterial.onClear();
        })
      }
    },
    onlyMySearch() {
      this.$refs.adasRecord.pagination.currentPage = 1;
      this.onSearch();
    },
    // 确认查询
    onSearch(value) {
      if (this.tabPaneValue == "first" && this.twoTabPaneValue == "first") {
        this.pagination.currentPage = 1;
        this.getItemCodeSearch();
      } else if (this.tabPaneValue == "first" && this.twoTabPaneValue != "first"){
        this.$refs.uuidRecord.pagination.currentPage = 1;
        this.$refs.uuidRecord.getUuidRecords();
      } else if (this.tabPaneValue=='adas') {
        this.$nextTick(() => {
          this.$refs.adasRecord.pagination.currentPage = 1;
          this.$refs.adasRecord.onSearch();
        });
      } else if (this.tabPaneValue=='blueWay') {
        this.$nextTick(() => {
          this.$refs.blueWay.pagination.currentPage = 1;
          this.$refs.blueWay.onSearch();
        });
      } else if (this.tabPaneValue=='lenovo') {
        this.$nextTick(() => {
          if(this.twoTabPaneValue=="lenovoPartCode") {
            this.$refs.lenovoPartCode.pagination.currentPage = 1;
            this.$refs.lenovoPartCode.onSearch();
          } else {
            this.$refs.lenovoMaterial.pagination.currentPage = 1;
            this.$refs.lenovoMaterial.onSearch();
          }
        });
      } else {
        this.virtualSearchForm.like = value;
        this.$nextTick(() => {
          this.$refs.virtualMaterial.pagination.currentPage = 1;
          this.$refs.virtualMaterial.onSearch();
        })
      }
    },
    // 查询/新建-编码类型改变
    itemTypeChange(formName) {
      this.$set(this[formName], "productType", undefined);
      this.$set(this[formName], "productId", undefined);
    },
    // 查询/新建-产品类别改变
    productTypeChange(value, formName, listName) {
      this.$set(this[formName], "productId", undefined);
      this.pullDownData[listName] = [];
      if (value) {
        this.getProductList(value, listName);
      }
    },
    // 虚拟物料查询-uuid类别改变
    uuidTypeChange() {
      this.$set(this.searchConditionForm, 'p2pType', '')
      this.$set(this.searchConditionForm, 'itemCode', '')
    },
    // 虚拟物料查询-是否已使用
    usedChange() {
      this.$set(this.searchConditionForm, "startDateTime", null);
      this.$set(this.searchConditionForm, "endDateTime", null);
    },
    // 虚拟物料查询-已使用开始时间
    startDateChange() {
      let { startDateTime, endDateTime } = this.searchConditionForm;
      if (startDateTime > endDateTime) {
        this.searchConditionForm.endDateTime = this.searchConditionForm.startDateTime;
      }
    },
    // 虚拟物料查询-已使用结束时间
    endDateChange() {
      let { startDateTime, endDateTime } = this.searchConditionForm;
      if (startDateTime > endDateTime) {
        this.searchConditionForm.startDateTime = this.searchConditionForm.endDateTime;
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getItemCodeSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getItemCodeSearch();
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getItemCodeSearch();
    },
    // 编码类型下拉
    async getItemCodeType() {
      const res = await apiItemCodeType();
      if (res.code == 0) {
        this.pullDownData.typeList = res.data;
      }
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    callback() {
      this.getItemCodeType();
      this.getProductTypeList();
      this.getUuidType();
      this.getP2PType();
      this.getCustomerList();
    },
    // uuid类别下拉
    async getUuidType() {
      const res = await apiUuidType();
      if (res.code == 0) {
        this.pullDownData.uuidTypeList = res.data;
      }
    },
    // Key类型下拉
    async getP2PType() {
      const res = await apiP2PType();
      if (res.code == 0) {
        this.pullDownData.P2PTypeList = res.data;
      }
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
     // 虚拟物料查询-已使用开始时间
    startUuidDateChange() {
      let { startDateTime, endDateTime } = this.searchConditionForm;
      if (startDateTime > endDateTime) {
        this.uuidRecordSearchForm.endDateTime = this.uuidRecordSearchForm.startDateTime;
      }
    },
    // 虚拟物料查询-已使用结束时间
    endUuidDateChange() {
      let { startDateTime, endDateTime } = this.searchConditionForm;
      if (startDateTime > endDateTime) {
        this.uuidRecordSearchForm.startDateTime = this.uuidRecordSearchForm.endDateTime;
      }
    },
     // 查询条件-员工
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
   // 员工选择表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {

       this.$set(this[origin], `${orderName}`,selectRow.join(','));
      
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      if (this.twoTabPaneValue == "first") {
        this.getItemCodeSearch("", this.callback);
      } else {
        this.$nextTick(() => {
          this.$refs.uuidRecord.getUuidRecords();
        });
      }
    } else if (this.tabPaneValue=='adas') {
      this.$refs.adasRecord.onSearch();
    } else if (this.tabPaneValue=='blueWay') {
      this.$refs.blueWay.onSearch();
    } else if (this.tabPaneValue=='lenovo') {
      if(this.twoTabPaneValue=="lenovoPartCode") {
        this.$refs.lenovoPartCode.onSearch();
      } else {
        this.$refs.lenovoMaterial.onSearch();
      }
    } else {
      this.$refs.virtualMaterial.virtualChange(this.virtualType, this.callback);
    }
  },
  deactivated() {
    window.onresize = null;
  },
     
};
</script>

<style lang="less" scoped>
.uploadDownBtn {
  /deep/.el-icon-d-arrow-right {
    transform: rotateZ(90deg);
  }
}
.downloadDropdown {
  margin-top: -4px;
  transform: translateX(12px);
  /deep/.popper__arrow {
    left: 46% !important;
  }
}
.uploadDropdown {
  margin-top: -4px;
  transform: translateX(15px);
  /deep/.popper__arrow {
    left: 46% !important;
  }
}
.el-dropdown-menu__item {
  padding: 0 16px;
}
</style>
